import { APIError } from "snudbud-backbone-sdk";

/**
 * Get friendly error message for auth errors
 */
export const getAuthErrorMessage = (error: any): string => {
  if (!error) return "An unknown error occurred";

  if (error.code === APIError.UnauthorizedCode.AccessTokenInvalid)
    return "Your session has expired. Please sign in again.";
  if (error.code === APIError.UnauthorizedCode.RefreshTokenInvalid)
    return "Your session is invalid. Please sign in again.";
  if (error.code === APIError.NotFoundCode.UserNotFound) return "User not found. Please check your credentials.";

  if (error.response?.status === 401) return "Authentication failed. Please check your credentials and try again.";
  if (error.response?.status === 403) return "You don't have permission to do this.";

  return "An unexpected error occurred";
};
